import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import { filterValidItems, isTruthyValue } from 'utils';

import { CapitalizedText, DescriptionText } from './StructuredListSection.styled';

export const StructuredListSection = ({ title, items = [] }) => {
  const validItems = filterValidItems(items);
  if (validItems.length === 0) return null;

  return (
    <Section title={title}>
      <List disablePadding>
        {validItems.map(item => {
          const { description, year, title: itemTitle, role } = item;

          return (
            <ListItem key={itemTitle} disableGutters>
              <ListItemText
                primary={
                  <>
                    {isTruthyValue(itemTitle) && (
                      <CapitalizedText>
                        <b>{itemTitle}</b>
                      </CapitalizedText>
                    )}

                    {isTruthyValue(role) && (
                      <CapitalizedText color="textSecondary">{role}</CapitalizedText>
                    )}

                    {isTruthyValue(description) && (
                      <DescriptionText color="textSecondary" component="pre">
                        {description}
                      </DescriptionText>
                    )}

                    {isTruthyValue(year) && <Typography color="textSecondary">{year}</Typography>}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Section>
  );
};
